import {Loadable} from 'app/components/general/lazyLoader';

import {LoadingBaseDiagram} from './LoadingBaseDiagram';

import type {Props} from './BaseDiagram';
export const LoadableBaseDiagram = Loadable<Error, Props>({
  loader: () =>
    import(
      /* webpackChunkName: "diagram" */
      './BaseDiagram'
    ),
  LoadingComponent: LoadingBaseDiagram,
});
